import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {GetDrawerNavigationBulkResponse_Banners} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {styled} from '@linaria/react';
import React from 'react';
import {CouponBanner} from '../../../features/Coupons/CouponBanner/CouponBanner';
import {DiscountCardWithData} from '../../../features/DiscountCardWithData/DiscountCardWithData';
import {DiscoverBanner} from '../../../features/HubPage/DiscoverBanner';
import {SimpleWebCouponWrapper} from '../../../features/WebCouponBanner/SimpleWebCouponBanner';
import {OFFCANVAS_DEFAULT_QUERY_PARAMETER} from '../useOffcanvasOpenState';

export const OffcanvasBannerView: React.FC<
  GetDrawerNavigationBulkResponse_Banners & {
    currentCategoryId?: string;
    isFirstCategoryLevelShown: boolean;
    isAppWelcomeCouponBannerEnabled?: boolean;
  }
> = ({
  elements,
  currentCategoryId,
  isFirstCategoryLevelShown,
  isAppWelcomeCouponBannerEnabled,
}) => {
  const {isActive: isHighTierCouponsActive} =
    useIsFeatureActive('high_tier_coupons');

  return (
    <Wrapper
      $marginTop={
        currentCategoryId === OFFCANVAS_DEFAULT_QUERY_PARAMETER &&
        elements.length > 0
      }
    >
      {elements.map((banner, index) => {
        switch (banner.type?.$case) {
          case 'highTierCouponBanner': {
            if (!isFirstCategoryLevelShown || !isHighTierCouponsActive) {
              return null;
            }

            return (
              <CouponBanner
                banner={banner.type.highTierCouponBanner}
                enableUrgencyLabel
                key={`highTierCouponBanner-${index}`}
              />
            );
          }
          case 'genericCouponBanner': {
            if (!isFirstCategoryLevelShown) {
              return null;
            }

            return isAppWelcomeCouponBannerEnabled ? (
              <SimpleWebCouponWrapper />
            ) : (
              <CouponBanner
                data-testid="couponWalletBanner"
                disableAnimation
                banner={banner.type.genericCouponBanner}
                key={`genericCouponBanner-${index}`}
              />
            );
          }
          case 'discountCardsSlot':
            return <StyledDiscountCard key={`discountCardsSlot-${index}`} />;
          case 'discoverBanner': {
            const bannerCategoryId = `${banner.type.discoverBanner.linkedCategoryId}`;

            if (currentCategoryId !== bannerCategoryId) {
              return null;
            }

            return (
              <DiscoverBanner
                {...banner.type.discoverBanner}
                key={`discoverBanner-${index}`}
              />
            );
          }
          default:
            return null;
        }
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div<{$marginTop: boolean}>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: calc(100% + 40px);
  margin-inline: -20px;

  margin-top: ${props => (props.$marginTop ? '16px' : 0)};
`;

const StyledDiscountCard = styled(DiscountCardWithData)`
  // always has a script element, so :not(:empty) will not work
  &:has(div) {
    margin: 0 16px;
    margin-top: 16px;
  }

  width: unset;
`;
